import { IBasket } from "../models/IBasket.model";
import { IBasketResponse } from "../models/IBasketResponse.model";
import { IProduct } from "../models/IProduct.model";
import { IYouMayAlsoLikeResponse } from "../models/IYouMayAlsoLikeResponse.model";
import { checkStatus, deleteRequest, get, post, put, toJson } from "../../../gulp/scripts/typescript/helpers/fetch";
import { IBasketToWishlistResponse } from "../models/IBasketToWishlistReponse";
import { IErrorResponse } from "../../../wishlistsrc/src/models/IErrorResponse";

class BasketService {

	async getBasket(): Promise<IBasket> {
		return get('/api/basket')
		.then(checkStatus)
		.then(toJson)
	}

	async updateLineItemQuantity(lineItemGuid: string, quantity: number): Promise<IBasketResponse> {

		return put(`/api/basket/lineitem/${lineItemGuid}`,
			{
				quantity: quantity
			}
		)
		.then(checkStatus)
		.then(toJson)
	}

	async removeLineItem(lineItemGuid: string): Promise<IBasketResponse> {
		return deleteRequest(`/api/basket/lineitem/${lineItemGuid}`)
		.then(checkStatus)
		.then(toJson)
	}

	async moveLineItemToWishlist(lineItemGuid: string, quantity: number, overrideQuantity: boolean): Promise<IBasketToWishlistResponse | IErrorResponse> {
		return put(`/api/basket/move-to-wishlist/${lineItemGuid}`, {
			quantity: quantity,
			overrideQuantity: overrideQuantity
		}
		)
		.then(checkStatus)
		.then(toJson)
	}

	async addDiscount(promotionCode: string): Promise<IBasketResponse> {
		return post(`/api/basket/promotioncode`,{
				promotionCode: promotionCode.toLowerCase()
			}
		)
		.then(checkStatus)
		.then(toJson)
	}

	async removeDiscount(promotionCode: string): Promise<IBasketResponse> {
		return deleteRequest(`/api/basket/promotioncode/${encodeURIComponent(promotionCode.toLowerCase())}`)
		.then(checkStatus)
		.then(toJson)
	}

	async getRecommendedExtras(productName: string): Promise<any> {
		return get(`/api/relatedproducts/recommendedextras?name=${productName}`)
			.then(checkStatus)
			.then(toJson)
	}

	async getYouMayAlsoLikeProducts(): Promise<IYouMayAlsoLikeResponse> {
		return get(`/api/basket/youmayalsolike`)
			.then(checkStatus)
			.then(toJson)
	}

	async addProduct(product: IProduct, quantity: number): Promise<any> {
		const body = 'id=' + product.Name + '&quantity=' + quantity.toString() + '&sku=' + product.Name;
		return post(`/api/basketadd/addorupdateajax`, null, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Cache-Control': 'no-cache'
			},
			body: body
			})
			.then(checkStatus)
			.then(toJson)
			.then(this.checkSucessBoolean)
	}

	/**
	 * Some old endpoints return 200 but have a Success boolean that is false
	 */
	private checkSucessBoolean(data: any) {
		if(data.Success) {
			return Promise.resolve(data);
		} else {
			return Promise.reject(new Error(data.Message));
		}
	}

}

export default BasketService;
